// extracted by mini-css-extract-plugin
module.exports = {"ecoCreditsDay":"EcoCreditsDay_ecoCreditsDay__iVkaO"};